import * as React from 'react'

import { useHistoriesWidget } from './hooks'
import { History } from './types'
import {
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import { Card } from 'antd'
import { getBadge } from '../../const'
import { path } from '../../../../libs'
import { ErrorScreen } from '../../../../shared/components/errorScreen/errorScreen'
import { historyMounted } from './model'

type Props = {
  clientId: string
  requestId: string
}

export const HistoriesWidget = ({ clientId, requestId }: Props) => {
  const { history, historiesError, loading } = useHistoriesWidget(clientId)

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  if (![0, 404, null].includes(historiesError?.code || null)) {
    return (
      <ErrorScreen
        showRetry
        onRetry={() => {
          historyMounted(clientId)
        }}
      />
    )
  }

  return (
    <CCard className="mb-3">
      <CCardHeader>
        <strong>History</strong>
      </CCardHeader>
      <CCardBody>
        <HistoriesList items={history} requestId={requestId} />
      </CCardBody>
    </CCard>
  )
}

type HistoriesListProps = {
  items: History[] | undefined
  requestId: string
}

const HistoriesList = ({ items, requestId }: HistoriesListProps) => {
  return (
    <>
      {items &&
        items?.length > 0 &&
        items?.map((item) => {
          if (item.requestId == requestId) {
            return ''
          }
          return (
            <Card className="mb-2" key={item.requestId} title={item.updatedAt}>
              <CRow>
                <CCol>
                  verify request:
                  <a
                    href={path.verificationsV2.details(item.requestId)}
                    target="_blank"
                  >
                    {item.requestId}
                  </a>
                </CCol>
                <CCol>
                  client ID:
                  <a href={path.clients.details(item.clientId)} target="_blank">
                    {item.clientId}
                  </a>
                </CCol>
                <CCol>
                  <CBadge color={getBadge(item.status)} className={'mb-1'}>
                    {item.status}
                  </CBadge>
                </CCol>
                <CCol>documentNumber: {item.documentNumber}</CCol>
                <CCol>
                  <p>reason: {item.reason}</p> <p>comment: {item.comment}</p>
                  {item.previousReason && (
                    <div>Previous Rejection reason: {item.previousReason}</div>
                  )}
                </CCol>
              </CRow>
            </Card>
          )
        })}
    </>
  )
}
